module.exports = __webpack_public_path__ + "static/media/third1.56825f74.svg";